import { render, staticRenderFns } from "./UserPage.html?vue&type=template&id=4ef14323&scoped=true&"
import script from "./UserPage.js?vue&type=script&lang=js&"
export * from "./UserPage.js?vue&type=script&lang=js&"
import style0 from "./UserPage.scss?vue&type=style&index=0&id=4ef14323&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef14323",
  null
  
)

export default component.exports